import React from 'react';
import clsx from "clsx";
import {TabsProps} from "./CouponTabs.types";
import {couponType, HIDE_NEED_CONFIRM_DIALOG, REMOVE_ALL_COUPON_EVENTS} from "../../store/spirs/actions";
import {ReactComponent as TrashIcon} from '../coupons/Lists/assets/trash_icon.svg';
import {useDispatch} from 'react-redux';


export const CouponTabs: React.FC<TabsProps> = (props) => {
    const dispatch = useDispatch();

    const onChange = (tabId: couponType) => () => {
        props.onChange(tabId);
    }

    function handleClose() {
        dispatch(REMOVE_ALL_COUPON_EVENTS());
        dispatch(HIDE_NEED_CONFIRM_DIALOG());
    }

    return (
    <>
        <div className="flex justify-between bg-[#272D33] rounded-[29px] h-[24px] desktop:h-[42px]">
            {props.tabs.map((tab, i) => (
                <div
                    key={i}
                    onClick={onChange(tab.value)}
                    className={clsx(
                        "w-full cursor-pointer flex gap-[2px] items-center rounded-[29px] text-[12px] desktop:text-[14px] font-['Roboto'] px-2 py-1 ml-[3px] mr-[3px]",
                        tab.badge > 0 ? "justify-between pl-2 desktop:pl-3 pr-0.5 gap-1 desktop:pr-[7px]" : "justify-center",
                        props.value === tab.value ? "text-white bg-[rgba(3,169,244,0.70)]" : "text-[#727374]")}
                >
                    {tab.label}
                    {tab.badge > 0 && (
                        <Badge active={props.value === tab.value}>
                            {tab.badge}
                        </Badge>
                    )}
                </div>
            ))}
        </div>
        <button onClick={handleClose} className={clsx("cursor-pointer border-l border-[#171A1E] w-4 h-4 desktop:w-7 desktop:h-7")}>
            <div className="flex justify-center items-center w-4 h-4 desktop:w-7 desktop:h-7">
                <TrashIcon />
            </div>
        </button>
    </>
    )
}

const Badge: React.FC<React.PropsWithChildren & {active: boolean}> = ({children, active}) => (
    <div className={clsx("min-h-[18px] min-w-[18px] mx-0.5 pr-[1px] desktop:ml-1 desktop:min-h-[28px] desktop:min-w-[28px] rounded-full flex items-center justify-center text-white text-[10px] desktop:text-[14px] font-['Roboto'] bg-[#FF5656]", active ? "bg-[#FF5656]" : "bg-[#727374]")}>
        {children}
    </div>
)
